











































import firebase, { firestore, functions } from "firebase";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MDDocument } from '../struct/mddocument';
import _ from 'underscore';

@Component
export default class MarkdownList extends Vue {
  docs: MDDocument[] = []
  private working = false
  private query_snapshot_unsubscriber!: () => void
  private title_filtering = ""

  get tail_document_id() {
    const l = this.docs.length
    return l > 0 ? this.docs[l-1].document_id : undefined
  }

  private ordering = {
    up_star: false,
    up_updated: false,
  }

  get filtered_docs() {
    const t = (this.title_filtering || "").trim()
    let ftd = t ? this.docs.filter(d => d.title.includes(t)) : this.docs
    if (this.ordering.up_updated) {
      ftd = _(ftd).sortBy(d => d.updated_at ? -d.updated_at.getTime() : 0)
    }
    if (this.ordering.up_star) {
      ftd = _(ftd).select(d => d.starred)
    }
    return ftd
  }

  async find() {
    if (this.working) { return }
    try {
      this.working = true
      const docs = await MDDocument.find_heads(this.tail_document_id)
      docs.forEach(d => this.docs.push(d)) 
      this.query_snapshot_unsubscriber = MDDocument.observe_heads(change => {
        console.log(change, change.doc.data())
        const doc = change.doc
        switch (change.type) {
        case "added":
        case "modified":
          (() => {
            const i = this.docs.findIndex(d => d.document_id === doc.id)
            if (0 <= i) {
              this.docs.splice(i,1,MDDocument.deserialize(doc))
            } else {
              this.docs.splice(0,0,MDDocument.deserialize(doc))
            }
          })()
          break
        case "removed":
          (() => {
            const i = this.docs.findIndex(d => d.document_id === doc.id)
            if (0 <= i) {
              this.docs.splice(i,1)
            }
          })()
          break
        }
      })
    } catch(e) {
      console.error(e)
    }
    this.working = false
  }

  go(path: string) { this.$router.push(path) }

  mounted() {
    this.find()
  }
}
